var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteSquareLogo = function SvgWhiteSquareLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_20120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.556 16.8692C29.556 14.7609 28.1599 13.2518 26.2744 13.2518C24.389 13.2518 23.0163 14.7609 23.0163 16.8692C23.0163 18.9774 24.3899 20.4625 26.2744 20.4625C28.159 20.4625 29.556 18.9533 29.556 16.8692ZM20.5714 16.8692C20.5714 13.5629 22.9921 11 26.2744 11C29.5568 11 32 13.5629 32 16.8692C32 20.1755 29.5793 22.7143 26.2744 22.7143C22.9695 22.7143 20.5723 20.1746 20.5723 16.8692",
    fill: "#1B382F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7806 30.0176C29.7806 27.9094 28.3496 26.4002 26.417 26.4002C24.4845 26.4002 23.0774 27.9094 23.0774 30.0176C23.0774 32.1258 24.4853 33.611 26.417 33.611C28.3487 33.611 29.7806 32.1018 29.7806 30.0176ZM20.5714 30.0176C20.5714 26.7113 23.0526 24.1484 26.417 24.1484C29.7815 24.1484 32.2857 26.7113 32.2857 30.0176C32.2857 33.3239 29.8045 35.8627 26.417 35.8627C23.0295 35.8627 20.5723 33.323 20.5723 30.0176",
    fill: "#FF9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7806 30.0176C29.7806 27.9094 28.3496 26.4002 26.417 26.4002C24.4845 26.4002 23.0774 27.9094 23.0774 30.0176C23.0774 32.1258 24.4853 33.611 26.417 33.611C28.3487 33.611 29.7806 32.1018 29.7806 30.0176Z",
    fill: "#FF9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2092 9.01509C17.2092 6.95828 15.7782 5.48589 13.8456 5.48589C11.913 5.48589 10.506 6.95828 10.506 9.01509C10.506 11.0719 11.9139 12.5208 13.8456 12.5208C15.7773 12.5208 17.2092 11.0484 17.2092 9.01509ZM8 9.01509C8 5.78942 10.4812 3.28906 13.8456 3.28906C17.21 3.28906 19.7143 5.78942 19.7143 9.01509C19.7143 12.2408 17.2331 14.7176 13.8456 14.7176C10.4581 14.7176 8.00089 12.2399 8.00089 9.01509",
    fill: "#FF5F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2092 9.01509C17.2092 6.95828 15.7782 5.48589 13.8456 5.48589C11.913 5.48589 10.506 6.95828 10.506 9.01509C10.506 11.0719 11.9139 12.5208 13.8456 12.5208C15.7773 12.5208 17.2092 11.0484 17.2092 9.01509Z",
    fill: "#FF5F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2092 22.2989C17.2092 20.1906 15.7782 18.6814 13.8456 18.6814C11.913 18.6814 10.506 20.1906 10.506 22.2989C10.506 24.4071 11.9139 25.8922 13.8456 25.8922C15.7773 25.8922 17.2092 24.383 17.2092 22.2989ZM8 22.2989C8 18.9925 10.4812 16.4297 13.8456 16.4297C17.21 16.4297 19.7143 18.9925 19.7143 22.2989C19.7143 25.6052 17.2331 28.144 13.8456 28.144C10.4581 28.144 8.00089 25.6043 8.00089 22.2989",
    fill: "#1B382F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_20120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white",
    transform: "translate(8 11)"
  })))));
};
export default SvgWhiteSquareLogo;